module.exports = __webpack_public_path__ + "img/title.695c74a7.svg";